import parse from 'html-react-parser';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import {
    Label,
} from "@progress/kendo-react-labels";
import { Error } from '../labels/Error';
import { DateTimePicker } from '../date-time/DateTimePicker';

function DateTimePickerFieldWrapper({
    title = "",
    value = null,
    defaultValue = null,
    disabled = false,
    canDelete = false,
    onChange = null,
    warnings = [],
    boldTitle = false,
    showSeconds = false,
    min = new Date(2014, 1, 10, 12, 30),
    max = new Date(2050, 2, 10, 12, 30),
    className = "",
    format = "",
    isRequired = false,
    showYear = false
}) {

    return (
        <FieldWrapper>
            {title && (
                <Label className="k-form-label font-size-md" style={{
                    fontWeight: boldTitle ? "500" : "normal"
                }} disabled={true}>
                    {parse(title)}:
                    {isRequired && <span style={{ color: "var(--warning-bg)", marginLeft: "0.25em" }}>*</span>}
                </Label>
            )}
            <div className="k-form-field-wrap">
                <DateTimePicker
                    title={title}
                    value={value}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    canDelete={canDelete}
                    onChange={onChange}
                    className={className}
                    showSeconds={showSeconds}
                    min={min}
                    max={max}
                    format={format}
                    showYear={showYear}
                />
            </div>
            {
                warnings.map((warning, index) =>
                    <Error key={index}>
                        {parse(warning)}
                    </Error>
                )
            }
        </FieldWrapper>
    );
}

export default DateTimePickerFieldWrapper;
